import { TextField } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import React from 'react';
import './index.scss';

class ConfirmationDialog extends React.Component {
  state = {
    value: '',
  };

  render() {
    const isYesNo = this.props.variant === 'yesNo';

    return (
      <Dialog
        classes={{
          paper: 'confirmation__dialog__paper',
        }}
        open={this.props.open}
        onClose={this.props.onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          disableTypography={isYesNo}
          classes={{
            root: isYesNo ? 'confirmation__dialog__yesNo__title__text' : '',
          }}
          id="confirmation-dialog-title"
        >
          {this.props.confirmationTitle}
        </DialogTitle>
        {(this.props.confirmationDescription || this.props.showInput) && (
          <DialogContent>
            <DialogContentText id="confirmation-dialog-description">
              {this.props.confirmationDescription}
            </DialogContentText>
            {this.props.showInput && (
              <TextField
                inputRef={ref => (this.inputField = ref)}
                style={{
                  marginTop: 20,
                  width: this.props.wideInput ? '100%' : 'auto',
                }}
                defaultValue={this.props.inputDefaultValue || null}
                label={this.props.inputLabel || 'Value'}
                placeholder={this.props.inputPlaceholder || 'Enter value'}
              />
            )}
          </DialogContent>
        )}
        <DialogActions
          className={isYesNo ? 'confirmation__dialog__yesNo__button__row' : ''}
        >
          <Button
            onClick={this.props.onClose}
            color="primary"
            className={isYesNo ? 'fatsoma__cta' : ''}
            autoFocus
          >
            {this.props.negativeActionText || 'No'}
          </Button>
          <Button
            onClick={e => {
              this.props.onConfirm(this.inputField ? this.inputField.value : e);
            }}
            className={isYesNo ? 'fatsoma__cta__secondary' : ''}
            color="primary"
          >
            {this.props.positiveActionText || 'Yes'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ConfirmationDialog;



// WEBPACK FOOTER //
// ./src/components/Utility/Dialogs/ConfirmationDialog.jsx